import moment from "moment"
import React, { useState } from "react"
import { Button, CardBody, Col, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row } from "reactstrap"
import PageBody from "../../../components/PageBody"
import Flatpickr from 'react-flatpickr'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import PhoneImageIcon from '../../../assets/images/icon-phone.png';
import IconEdit from '../../../assets/images/icon-edit.png';
import Select from 'react-select';
import IconCalendar from '../../../assets/images/icon/ic_calendar-black.svg';
import { ExaminationForm, ExaminationType } from "../../../constants/nutriconstant"
import CalcUtils from "../../../helpers/CalcUltils"
import { cloneDeep, isEmpty } from "lodash"
import { toast } from "react-toastify"
import ModalPopup from "../../../components/ModalPopup"
import CustomerAdd from "../../customer/CustomerAdd"
import { useHistory } from "react-router"
import NumberFormat from "react-number-format"
import TextUtils from "../../../helpers/TextUtils"
import ToggleButton from "../../../common/ToggleButton"
import { ValueText } from "../ProductAdd"
import { ProductType } from "../ProductList"
import { WithContext as ReactTags } from 'react-tag-input';

const ProductAattributes = (props: any) => {
    const { data, setData, type, onlyView, attributes, setAttributes, validation, onValidation } = props

    const handleAttributesAdd = () => {
        const newDetailtiveUser = {
            name: "",
            properties:[],
        };
        setAttributes([...attributes, newDetailtiveUser]);
    };

    const handleAttributesUpdate = (dataDetail: any, index: number) => {
        let newDetailtiveUser = cloneDeep(attributes);
        newDetailtiveUser[index] = dataDetail;
        setAttributes(newDetailtiveUser);
        const stockValidation = {
            ...validation?.attributes
        }
        if(!stockValidation[index]) stockValidation[index] = {}
        const item = dataDetail
        stockValidation[index].properties = stockValidation[index].name = ''
        if(item?.name && item?.properties?.length === 0) stockValidation[index].properties = 'Giá trị không được để trống!'
        if(!item?.name && item?.properties?.length !== 0) stockValidation[index].name = 'Tên thuộc tính không được để trống!'
        onValidation({
            ...validation,
            attributes: stockValidation
        })
    };

    const handleAttributesRemove = (index: number) => {
        let newDetailtiveUser = cloneDeep(attributes);
        newDetailtiveUser.splice(index, 1);
        if(newDetailtiveUser?.length === 0) newDetailtiveUser = [{
            name: "",
            properties:[],
        }]
        setAttributes(newDetailtiveUser);
    };

    return (
        <PageBody>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div className="nutri-title mb-3">Thuộc tính</div>
                <ToggleButton isDisabled={type == 'view' ? true: false} elmChecked={data?.attributes_status == 1 ? true : false} data={data} setData={(data:any) => {setData(data)}} name='attributes_status' />
            </div>
            {data?.attributes_status == 1 &&
                attributes?.map((item:any, index:number) => (
                    <AttributesItem 
                        detailIndex={index} 
                        data={item}
                        onChangeData={(dataDetail: any) =>
                            handleAttributesUpdate(dataDetail, index)
                        }
                        validation={validation && validation.attributes && validation.attributes[index]}
                        type={type}
                        onlyView={onlyView}
                        handleRemoveData={() => handleAttributesRemove(index)}
                        handleAddData={() => handleAttributesAdd()}
                        detail={attributes}
                    />
                ))
            }
        </PageBody>
    )
}

const AttributesItem = (props:any) => {
    const {detailIndex, detail, onChangeData, data, type, onlyView, handleRemoveData, handleAddData, validation} = props
    const KeyCodes = {
        comma: 188,
        enter: 13
      };
      
    const delimiters = [KeyCodes.comma, KeyCodes.enter];
    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        if(name == 'name') {
            if(value?.length > 200) return
        }
        onChangeData({
            ...data,
            [name]: value
        })
    }

    const setTags = (value:any)=>{
        onChangeData({
            ...data,
            properties: value
        })
    }

    const handleDelete = (i:any) => {
        const item = data?.properties[i]
        if(item?.product_id){
            toast.warning("không thể xóa giá trị này")
            return
        }
        setTags(data?.properties.filter((tag:any, index:number) => index !== i));
    };
    
    const handleAddition = (tag:any) => {
        setTags([...data?.properties, {
            ...tag,
            name: tag?.text,
        }]);
    };
    
    const handleDrag = (tag:any, currPos:any, newPos:any) => {
        const newTags = data?.properties?.slice();
        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
        setTags(newTags);
    };
    
    const handleTagClick = (index:number) => {
        console.log('The tag at index ' + index + ' was clicked');
    };
    
    return (
        <Row key={detailIndex}>
            <Col md={4} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Tên thuộc tính</Label>
                    <InputGroup>
                        <Input type="text" value={data?.name} onChange={(e: any) => handleChangeData(e)} name="name" placeholder="Nhập tên đơn vị..." />
                        {validation?.name &&<div className="invalid-feedback d-block" >{validation?.name}</div>}
                    </InputGroup>
                </FormGroup>
            </Col>
            <Col md={7} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label>Giá trị</Label>
                    <ReactTags
                        delimiters={delimiters}
                        tags={data?.properties}
                        handleDelete={handleDelete}
                        handleAddition={handleAddition}
                        // handleDrag={handleDrag}
                        handleTagClick={handleTagClick}
                        inputFieldPosition="bottom"
                        autocomplete
                        readOnly={type === 'view'}
                        placeholder='Thêm giá trị...'
                    />
                    {validation?.properties &&<div className="invalid-feedback d-block" >{validation?.properties}</div>}
                </FormGroup>
            </Col>
            {!onlyView &&
            <Col md={1} xs={12}>
                <FormGroup className='nutri-form'>
                    <Label></Label>
                    <Button onClick={handleRemoveData} className='nutri-square bg-none' color='success'><i className='uil-trash-alt'></i></Button>
                    {
                        detail?.length == detailIndex+1 &&
                        <Button onClick={handleAddData} className='nutri-square mt-2' color='success'><i className='uil-plus'></i></Button>
                    }
                </FormGroup>
            </Col>}
        </Row>
    )
}

export default ProductAattributes